module.exports = "/assets/about/success/fba2019.png?YtxNa3q";